function bindMorePanel({ panelId, openId, closeId }) {
  const panel = document.getElementById(panelId);
  const openBtn = document.getElementById(openId);
  const closeBtn = document.getElementById(closeId);

  if (!panel || !openBtn || !closeBtn) return;
  if (openBtn.dataset.morePanelBound === panelId) return;

  openBtn.dataset.morePanelBound = panelId;
  closeBtn.dataset.morePanelBound = panelId;

  panel.classList.remove('is-open');
  openBtn.classList.remove('is-hidden');

  openBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    panel.classList.add('is-open');
    openBtn.classList.add('is-hidden');
  });

  closeBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    panel.classList.remove('is-open');
    openBtn.classList.remove('is-hidden');
  });
}

function initMorePanel() {
  bindMorePanel({ panelId: 'more', openId: 'more-open', closeId: 'more-close' });
  bindMorePanel({ panelId: 'more2', openId: 'more-open2', closeId: 'more-close2' });
}

document.addEventListener('DOMContentLoaded', initMorePanel);
document.addEventListener('shopify:section:load', initMorePanel);
